// import { createSelector } from '@reduxjs/toolkit';
// Models
import { RootState } from 'store';

export const selectThreadId = (state:RootState) => state.quizAgent.threadId;
export const selectMessages = (state:RootState) => state.quizAgent.messages;
export const selectDraftQuiz = (state:RootState) => state.quizAgent.draftQuiz;
export const selectLoading = (state:RootState) => state.quizAgent.loading;
export const selectStreamingActivities = (state:RootState) => state.quizAgent.streamingActivities;
